const fetch = require('node-fetch');

const endpoint = 'https://api.xgames.zone';

const getItem = (id, storage = '') => {
  return fetch(`${endpoint}/item/${id}?storage=${storage}`, {
    headers: {},
  }).then(res => {
    if (res.status === 200) {
      return res.json();
    }
    throw new Error(`Not Found: ${JSON.stringify(res)}`);
  });
};

const download = (id, n, storage, token, provider) => {
  return fetch(`${endpoint}/item/${id}/download?n=${parseInt(n) || 0}&storage=${storage}`, {
    method: 'post',
    body: JSON.stringify({
      token,
      provider,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
  })
  .then(res => {
    return res.json();
  })
  .catch(err => {
    throw new Error(`Not Found: ${JSON.stringify(err)}`);
  });
};

const subscribe = (data) => fetch(`${endpoint}/subscription/subscribe`, {
  method: 'post',
  body: JSON.stringify(data),
  headers: {
    'Content-Type': 'application/json',
  },
});

module.exports = {
  getItem,
  download,
  subscribe,
};
